<form novalidate [formGroup]="commentForm">
    <h2 mat-dialog-title>
        {{ title ? title : ('commentsDialog.defaultTitle' | t) }}
    </h2>
    <mat-dialog-content style="min-width: 750px">
        @if (loading) {
            <div class="fancy-loader"></div>
        } @else {
            <mat-tab-group
                (selectedTabChange)="tabChange($event)"
                mat-align-tabs="center"
                animationDuration="0ms"
            >
                <mat-tab [label]="'commentsDialog.tabComment' | t">
                    <div class="container">
                        <div class="input-container pt-3">
                            @if (showProgress) {
                                <div>
                                    <mat-label>{{ 'commentsDialog.progressLabel' | t }}</mat-label>
                                    <mat-slider
                                        min="0"
                                        max="100"
                                        step="5"
                                        discrete
                                        thumbLabel
                                        showTickMarks
                                        ><input matSliderThumb formControlName="progress" />
                                    </mat-slider>
                                </div>
                            }

                            @if (showFeasibility) {
                                <mat-form-field>
                                    <mat-label>{{ 'commentsDialog.feasibilityLabel' | t }}</mat-label>
                                    <mat-select formControlName="feasibilityId">
                                        <mat-option>{{ 'commentsDialog.feasibilityNone' | t }}</mat-option>
                                        @for (feasibility of feasibilities; track feasibility) {
                                            <mat-option [value]="feasibility.id">
                                                {{ feasibility.name }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            }

                            <mat-label>{{ 'commentsDialog.commentLabel' | t }}</mat-label>
                            <cerrix-textarea
                                data-uiid="moi-comments-comment-textarea"
                                [errorLabel]="'commentsDialog.commentLabel' | t"
                                formControlName="comment"
                                [rows]="maxCommentRows"
                                [required]="commentRequired"
                            ></cerrix-textarea>
                        </div>
                    </div>
                </mat-tab>
                @if (comment.id && comment.id > 0) {
                    <mat-tab [label]="'commentsDialog.tabHistory' | t">
                        <div class="container">
                            @if (histories) {
                                <table mat-table [dataSource]="histories" class="col-md-12">
                                    <ng-container matColumnDef="modifiedAt">
                                        <th mat-header-cell *matHeaderCellDef>{{ 'commentsDialog.historyEditedOn' | t }}</th>
                                        <td mat-cell *matCellDef="let history">
                                            {{ history.modifiedAt | dateFormat }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>{{ 'commentsDialog.historyAction' | t }}</th>
                                        <td mat-cell *matCellDef="let history">
                                            {{ history.action }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="modifiedBy">
                                        <th mat-header-cell *matHeaderCellDef>{{ 'commentsDialog.historyEditedBy' | t }}</th>
                                        <td mat-cell *matCellDef="let history">
                                            {{ history.modifiedBy }} <br />
                                            <i>{{ history.modifiedByRole }}</i>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="comment">
                                        <th mat-header-cell *matHeaderCellDef>{{ 'commentsDialog.historyComment' | t }}</th>
                                        <td mat-cell *matCellDef="let history">
                                            {{ history.comment }}
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="columnsToDisplay; sticky: true"
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="let history; columns: columnsToDisplay"
                                    ></tr>
                                </table>
                            } @else {
                                <div class="fancy-loader"></div>
                            }
                        </div>
                    </mat-tab>
                }
            </mat-tab-group>
        }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button
            mat-button
            data-uiid="moi-comments-save-button"
            [disabled]="!commentForm.valid"
            (click)="saveClick()"
        >
            {{ 'commentsDialog.saveBtn' | t }}
        </button>
        <button mat-button mat-dialog-close>{{ 'commentsDialog.cancelBtn' | t }}</button>
    </mat-dialog-actions>
</form>
